import { setCanonicalAsciiByKeyGetter } from './catalog-alias-map';
import { buildUnitRegistry, type UnitRegistry } from './registry';
import { UNIT_CATALOG } from '../unit-catalog';

export const unitRegistry: UnitRegistry = buildUnitRegistry(UNIT_CATALOG);

setCanonicalAsciiByKeyGetter(() => unitRegistry.canonicalAsciiByKey);
